import React, { createContext, useContext, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";

import QuaiboDailyProductionStore from "../../../../store/quaibodailyproductionstore";

import { toJS } from "mobx";
import moment from "moment";
import { Button, Radio, Space, Switch, Tooltip } from "antd";
import {
  BarChartOutlined,
  BarsOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const RythmChart = React.forwardRef((props, ref) => {
  const [chartType, setChartType] = useState("line");
  const [showLabel, setShowLabel] = useState(false);
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);

  let data = [];

  switch (props.dataType) {
    case "production":
      switch (props.type) {
        case "Oil":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.oil)
          );
          break;
        case "Gas":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.gas)
          );
          break;
        case "NGL":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.condensate)
          );
          break;
        case "Boe":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.condensate + x.oil + (x.gas * 1000) / 6)
          );
          break;

        default:
          break;
      }
      break;
    case "evacuation":
      switch (props.type) {
        case "Oil":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.crudeInjectionGGF)
          );
          break;
        case "Gas":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.evacuatedGas)
          );
          break;
        case "NGL":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.condensate)
          );
          break;
        case "Boe":
          data = [...quaiboDailyProductionStore.dailyProductions.values()].map(
            (x) =>
              toJS(
                x.condensate + x.crudeInjectionGGF + (x.evacuatedGas * 1000) / 6
              )
          );
          break;

        default:
          break;
      }
      break;

    default:
      break;
  }

  return (
    <Observer>
      {() => (
        <>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm3"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  paddingLeft: "10px",
                  paddingTop: "10px",
                }}
              >
                <Switch
                  checkedChildren="Hide value labels"
                  unCheckedChildren="Show value labels"
                  defaultChecked={false}
                  onChange={(args) => {
                    setShowLabel(args);
                  }}
                />
              </div>
              <div
                className="ms-Grid-col ms-sm9"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "5px",
                  paddingRight: "10px",
                }}
              >
                <Radio.Group
                  defaultValue="line"
                  buttonStyle="solid"
                  onChange={({ target }) => {
                    setChartType(target.value);
                  }}
                >
                  <Radio.Button value="line">
                    <Tooltip placement="topLeft" title="switch to Line Chart">
                      <LineChartOutlined />
                    </Tooltip>
                  </Radio.Button>
                  <Radio.Button value="column">
                    <Tooltip placement="topLeft" title="switch to Column Chart">
                      <BarChartOutlined />{" "}
                    </Tooltip>
                  </Radio.Button>
                  <Radio.Button value="bar">
                    <Tooltip placement="topLeft" title="switch to Bar Chart">
                      <BarsOutlined />
                    </Tooltip>
                  </Radio.Button>
                </Radio.Group>
              </div>
            </div>
          </div>

          <HighchartsReact
            ref={ref}
            highcharts={Highcharts}
            options={{
              chart: {
                type: chartType,
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                text: props.title,
                style: { fontSize: "14px" },
              },

              xAxis: {
                categories: [
                  ...quaiboDailyProductionStore.dailyProductions.values(),
                ].map((x) => toJS(x.productionDate)),
                crosshair: true,
                title: {
                  text: "Production",
                },
                labels: {
                  formatter: (args) => moment(args.value).format("MMM DD"),
                },
              },
              yAxis: {
                min: 0,
                title: {
                  text: props.seriesName,
                },
              },
              tooltip: {
                headerFormat:
                  '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat:
                  '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y:.1f} bopd</b></td></tr>',
                footerFormat: "</table>",
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.2,
                  borderWidth: 0,
                },
              },
              series: [
                {
                  name: props.seriesName,
                  data,
                  color: props.fluidColor,

                  dataLabels: {
                    enabled: showLabel,
                    formatter: function () {
                      if (this.y > 1000000) {
                        return (
                          Highcharts.numberFormat(this.y / 1000000, 1) + "M"
                        );
                      } else if (this.y > 1000) {
                        return Highcharts.numberFormat(this.y / 1000, 1) + "K";
                      } else {
                        return this.y;
                      }
                    },
                  },
                },
              ],
              responsive: {
                rules: [
                  {
                    condition: {
                      maxWidth: 1000,
                    },
                    chartOptions: {
                      legend: {
                        floating: false,
                        layout: "horizontal",
                        align: "center",
                        verticalAlign: "bottom",
                        x: 0,
                        y: 0,
                      },
                      yAxis: [
                        {
                          labels: {
                            align: "right",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          labels: {
                            align: "left",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          visible: false,
                        },
                      ],
                    },
                  },
                ],
              },
            }}
          />
        </>
      )}
    </Observer>
  );
});

